  <nav class="main-menu d-none d-md-block" *ngIf="currentPage!='/'">

  <div class="" id="style-1">

    <ul class="p-1 p-lg-2 p-xl-3">
      <ng-container *ngFor="let nav of navs">
        <li *ngIf="nav.type.includes(type)"  [ngClass]="nav.href==currentPage?'active':''" >
          <a [routerLink]="nav.href">
            <img class="mr-2" [src]="nav.icon"/>
            <span class="nav-text ">{{nav.name}}</span>
          </a>
        </li>
      </ng-container>


    </ul>
  </div>



</nav>

<div class="modal fade" id="settings" role="dialog">
  <div class="modal-dialog " >

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header background-blue-g">
        <h4 class="modal-title">   الإعدادات </h4>
        <span class="modal-title pull-left"><i data-dismiss="modal"  class="fa fa-times-circle pointer"></i>  </span>

      </div>
      <div class="modal-body text-left">
<!--<app-settings></app-settings>-->
      </div>

    </div>

  </div>
</div>
